import { ButtonEmptyPermissioned } from "components/ButtonEmptyPermissioned/ButtonEmptyPermissioned";

interface ColumnGroupHeaderActionRemoveGroupProps {
  onClick: () => void;
  isDisabled?: boolean;
}

export const ColumnGroupHeaderActionRemoveGroup = ({
  onClick,
  isDisabled = false,
}: ColumnGroupHeaderActionRemoveGroupProps) => {
  return (
    <ButtonEmptyPermissioned
      requiredPermission="edit"
      aria-label="Remove column group"
      onClick={onClick}
      iconType="trash"
      color="text"
      size="s"
      disabled={isDisabled}
    >
      Remove column group
    </ButtonEmptyPermissioned>
  );
};
